import React, {useEffect, useRef} from 'react'
import {useParams} from 'react-router-dom'
import {JsonViewer} from '../../../../../../../common/JsonViewer.jsx'
import {HeaderTitle} from '../../../../../../../common/HeaderTitle.jsx'
import RyzykaRepeater from "../parts/RyzykaRepeater.jsx";
import {useProjektData} from '../../../../../../../../api/domain/elementyRejstru/queries/useProjektData.jsx'
import {Alert} from "react-bootstrap";

const Ryzyka = ({ data: props }) => {
    const {rejestrId} = useParams()
    const prefilledRef = useRef(false)

    const {data: projektData} = useProjektData(rejestrId, !!rejestrId)

    useEffect(() => {
        if (prefilledRef.current) return
        if (!props.wiz || !projektData) return

        const current = props.wiz.form || {}
        const currentList = current.ryzyka_list
        if (Array.isArray(currentList) && currentList.length > 0) return

        const kpRisks = Array.isArray(projektData?.ryzyka_list)
            ? projektData.ryzyka_list
            : []

        const nextRisks = kpRisks.map((r) => ({
            kategoria: r?.kategoria ?? '',
            ryzyko: r?.ryzyko ?? r?.opis ?? '',
            prawdopodobienstwo: r?.prawdopodobienstwo ?? '',
            skutek: r?.skutek ?? '',
            poziom: r?.poziom ?? '',
            status: r?.status ?? 'Aktualne',
            przyczyna: r?.przyczyna ?? '',
            propozycja: r?.propozycja ?? '',
            termin_dzialan_zapobiegawczych: r?.termin_dzialan_zapobiegawczych ?? '',
            osoba_monitorujaca: 'Kierownik projektu',
        }))

        prefilledRef.current = true
        props.wiz.setWizForm({
            ...current,
            ryzyka_list: nextRisks,
        })
    }, [props.wiz, projektData])

    return (
        <>
            <JsonViewer src={props.wiz?.form || {}} show={false}/>

            <HeaderTitle noHr size={'fs-3'} title={'C. Ryzyka Projektowe'}/>
            <HeaderTitle
                noHr
                size={'fs-4'}
                title={'Monitorowanie i aktualizacja rejestru ryzyk projektowych'}
            />

            <Alert className={'text-start fw-normal'} variant="info">
                W przypadku projektów zakończonych należy potwierdzić, że zidentyfikowane na etapie realizacji projektu ryzyka nie występują już po jego zakończeniu (w takim przypadku jako status ryzyka wskazać należy „ustąpiło”).
            </Alert>

            <div className={'d-flex flex-column gap-3'}>
                <RyzykaRepeater wiz={props.wiz} parentListName={'ryzyka_list'} />
            </div>
        </>
    )
}

export default Ryzyka
